import { MbscEventCreatedEvent } from '@mobiscroll/react';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { usePayers } from 'src/features/add-trip/Pricing/usePayers';

import { getExistingMultiloadTripIdsForAssignment } from '../../common/getExistingMultiloadTripIdsForAssignment';
import { getPotentialMultiloadCandidatesForUnassignedTrip } from '../../common/getPotentialMultiloadCandidatesForUnassignedTrip';
import { dispatcherSlice } from '../../dispatcher.slice';
import { useTripMenuActions } from '../useTripMenuActions';

export function useOnEventCreated() {
  const dispatch = useAppDispatch();
  const menuActions = useTripMenuActions();
  const assignedTrips = useAppSelector(
    (state) => state.dispatcher.dispatchResponse?.assigned_trips
  );
  const { payers } = usePayers();

  return async (newEvent: MbscEventCreatedEvent) => {
    const { hasPotentialMultiloadTripsAssigned, potentialMultiloadTripIds } =
      getPotentialMultiloadCandidatesForUnassignedTrip(
        newEvent.event.resource as string,
        newEvent.event.trip,
        assignedTrips,
        payers?.results
      );

    if (
      hasPotentialMultiloadTripsAssigned &&
      potentialMultiloadTripIds.length > 0
    ) {
      const assignmentId = newEvent.event.resource as string;
      const existingMultiloadTripIds =
        getExistingMultiloadTripIdsForAssignment(
          potentialMultiloadTripIds,
          assignedTrips
        );

      if (existingMultiloadTripIds.length > 0) {
        menuActions.assignToExistingMultiLoad(
          newEvent.event.trip.id,
          assignmentId,
          existingMultiloadTripIds
        );
      } else {
        menuActions.multiloadAssign(
          newEvent.event.trip.id,
          assignmentId,
          potentialMultiloadTripIds
        );
      }
    } else {
      await menuActions.assign(
        newEvent.event.trip.id,
        newEvent.event.resource as string,
        newEvent.event.trip.status
      );
    }
    dispatch(dispatcherSlice.actions.onCalendarEventDragEnd());
  };
}
